import React from 'react'
import PropTypes from 'prop-types'


import Form from 'component/utils/Form'

import CloseIconSVG from 'component/svgComponents/close'


const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const SideFilterForm = ({
  depositList,
  fields,

  setValueToField,
  sideFilterVisible,
  submit,
  translate,
  btnDisabled,

  closeFilters,
  values,
}) => {
  const renderOptions = (idDepositList, field, id) => {

    const renderOption = (deposit) => {
      const { idDeposit } = deposit
      const currentValue = values[field]
      const checked = idDepositList.some((depositId) => depositId === idDeposit)
      return (
        <div className='stock-transfer-options' onClick={() =>

          setValueToField(
            fields[field].input.name,
            checked
              ? currentValue.filter((i) => i !== idDeposit)
              : [...currentValue, idDeposit]
          )
        }>
        <label

          className='stock-transfer-label'
          key={idDeposit}

          style={{ display: 'block', margin: '.5rem auto', fontWeight: checked ? 'bold' : 'normal' }}
        >
          {deposit.idDeposit === "" ? deposit.dsDeposit : `${deposit.idDeposit} - ${deposit.dsDeposit}`}
        </label>
        <input checked={checked} className='margin-right stock-transfer-checkbox' type={"checkbox"} />
        </div>

      )
    }


    return (
      <>
        <strong style={{ display: 'block', margin: '1rem auto' }}>
          {translate(`stockTransfer.missionBlock.${id}.old`)}
        </strong>
        {depositList.map(renderOption)}
      </>
    )
  }

  const resetFilter = () => {
    setValueToField('idSourceDepositList', [])
    setValueToField('idDestinationDepositList', [])
  }
  const submiteValues = () => {
    submit(values)
    closeFilters()
  }
  return (
    <>
    <div style={{display: sideFilterVisible ? 'shown' : 'none'}} className='bg-filter' />
      <div style={{display: sideFilterVisible ? '' : 'none'}} className='right-filter-container'>
        <CloseIconSVG className="right-filter-svg" onClick={() => closeFilters()} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>

        {renderOptions(
          values.idSourceDepositList,
          'idSourceDepositList',
          'source'
        )}
        {renderOptions(
          values.idDestinationDepositList,
          'idDestinationDepositList',
          'destination'
        )}
        <div style={{marginTop: '30px'}} className='flex flex-row gap-filters'>

          <button
            className={`btn btn-danger-outline  full-w`}s
            onClick={resetFilter}>
            {translate('suggestions.cleanFilters')}
          </button>


          <button
            className={`btn btn-primary  full-w`}
            disabled={btnDisabled }
            onClick={submiteValues}
            >
              {translate('commonReport.filter')}
          </button>

        </div>
    </div>
  </>

  )
}

SideFilterForm.propTypes = {
  depositList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  handleSideFilterElementChange: PropTypes.func.isRequired,
  setValueToField: PropTypes.func.isRequired,
  sideFilterVisible: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  btnDisabled: PropTypes.bool.isRequired,
  resetFilters: PropTypes.func.isRequired,
  closeFilters: PropTypes.func.isRequired
}

export default Form({ fields: FIELDS })(SideFilterForm)

export { SideFilterForm }
